export class ConfigurationVolume {
  fileMountPath = '';

  rootMountPath = '';

  configurationKey = '';

  configurationName = '';
}
